/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "2978213b7d0f4501a5942ccbb925d54e",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "2978213b7d0f4501a5942ccbb925d54e",
            "region": "us-east-1"
        }
    },
    "aws_cognito_identity_pool_id": "us-east-1:4e23cf93-298d-4524-92d3-dd30a43db75a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_azsO85PeM",
    "aws_user_pools_web_client_id": "37fjb2mha404qtsju3asbq6fo8",
    "oauth": {
        "domain": "freightgptd8272706-d8272706-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://www.freightgpt.com/chat/",
        "redirectSignOut": "https://www.freightgpt.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
